<script lang="ts">
    import { highlighters, highlightsReady } from "@store/highlights"
    import { sideMenuOpen } from "./SideMenu.svelte"
    import HighlightCircle from "@components/highlighting/HighlightCircle.svelte"
</script>

{#if $highlightsReady}
    <div class="highlighter-list">
        {#each [...$highlighters] as [id, { label, light, dark }], i}
            <a
                aria-label={`see highlighter ${label ? label : i}`}
                on:click={() => ($sideMenuOpen = false)}
                href={"/account/highlights?highlighter=" + id}
                class="highlighter-link"
            >
                <HighlightCircle lightColor={light} darkColor={dark} />
            </a>
        {/each}
    </div>
{/if}

<style>
    .highlighter-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        padding-block: 0.15rem;
    }

    .highlighter-link {
        display: block;
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 999px;
        text-decoration: none;
    }

    .highlighter-link:focus-visible {
        outline: 2px solid var(--color-gold-400);
        outline-offset: 2px;
    }
</style>
